import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { authService } from '../services/api';

const ProtectedRoute = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [shouldRedirect, setShouldRedirect] = useState(null);
  
  const token = localStorage.getItem('token');
  const user = authService.getCurrentUser();
  const selectedHotel = authService.getSelectedHotel();

  useEffect(() => {
    const checkAuth = async () => {
      if (!token || !user) {
        setShouldRedirect('/login');
        setIsLoading(false);
        return;
      }

      // Se já tem hotel selecionado, permitir acesso
      if (selectedHotel) {
        setShouldRedirect(false);
        setIsLoading(false);
        return;
      }

      // Se não tem hotel selecionado, redirecionar para seleção
      setShouldRedirect('/select-hotel');
      setIsLoading(false);
    };

    checkAuth();
  }, [token, user, selectedHotel]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">Verificando autenticação...</p>
        </div>
      </div>
    );
  }

  if (shouldRedirect) {
    return <Navigate to={shouldRedirect} replace />;
  }

  return children;
};

export default ProtectedRoute; 